import type { Theme } from '@mui/material';

export const styles = {
  confidentialLogo: (theme: Theme) => ({
    py: 1,
    px: 2,
    borderTop: `2px solid ${theme.colors.black}`,
    borderBottom: `2px solid ${theme.colors.black}`,
  }),

  subline: {
    textAlign: 'center',
    py: 1,
  },
};
